import React, { useState, useEffect } from "react";
import "./ProfileCard.css";
import {
  FaUser,
  FaPhone,
  FaEnvelope,
  FaCalendarAlt,
  FaGift,
  FaKey,
  FaIdCard,
  FaMobileAlt,
  FaMoneyBillWave,
  FaUsers,
} from "react-icons/fa";
import { RiBankLine } from "react-icons/ri";
import { BsCardList, BsInfoCircleFill } from "react-icons/bs";


const Card = ({ title, color, icon, data, className = "" }) => {
  return (
    <div className={`all-card dashboard-card-container profile-card ${className}`}>
      <div className="all-card-content dashboard-content">
        <h2>{title}</h2>
        <div className="all-time-container">
          <div className="all-time-left">
            <h6 className="all-time-res">{data}</h6>
          </div>
        </div>
      </div>
      <div className={`all-card-icon ${color}`}>
        <img src={icon} alt={title} className="all-icon" />
      </div>
    </div>
  );
};


const ProfileCard = ({ selectedUser: userId, setActiveTab }) => {

  const [users, setUsers] = useState([]);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [todaysBids, setTodaysBids] = useState([]);
  const [filterType, setFilterType] = useState("Bullish");
  const [selectedBid, setSelectedBid] = useState(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [bullishBids, setBullishBids] = useState(0);
  const [bearishBids, setBearishBids] = useState(0);
  const [selectedUserId, setSelectedUserId] = useState(userId || localStorage.getItem('selectedUserId'));
  const [selectedUserInfo, setSelectedUserInfo] = useState(null);
  const [referredByName, setReferredByName] = useState("NA");
  const [bankNiftyBids, setBankNiftyBids] = useState([]);
const getTodayCode = () => {
  const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  return days[new Date().getDay()];
};
const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
const daycode = days[new Date().getDay()];
const normalBidsCount = todaysBids.filter(bid => bid.freeBid === false).length;

const todayBankNiftyCount = bankNiftyBids.filter(
  bid => bid.dayCode === daycode
).length;

const totalTodaysBids = normalBidsCount + todayBankNiftyCount;


const [selectedBNDay, setSelectedBNDay] = useState(getTodayCode());

  const bankNiftyCounts = React.useMemo(() => {
    const counts = { MON: 0, TUE: 0, WED: 0, THU: 0, FRI: 0 };
    bankNiftyBids.forEach((bid) => {
      if (counts[bid.dayCode] !== undefined) counts[bid.dayCode]++;
    });
    return {
      ...counts,
      total: bankNiftyBids.length
    };
  }, [bankNiftyBids]);

  // Simulating data loading
  useEffect(() => {
    // Simulate a delay, like fetching user data
    setTimeout(() => {
      setLoading(false); // Set loading to false after 3 seconds (simulate loading)
    }, 1000);
  }, []);


  // Fetch users from API
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await fetch("https://prod-erp.nifty10.in/users/list");
        const data = await response.json();

        if (data?.content) {
          setUsers(data.content);

          // Find and store referredBy name
          const selectedUser = data.content.find(user => user.userId === selectedUserId);
          const referredByCode = selectedUser?.referredBy;

          if (referredByCode) {
            const referrer = data.content.find(user => user.referralCode === referredByCode);
            setReferredByName(referrer?.name || "NA");
          } else {
            setReferredByName("NA");
          }

        } else {
          setError("Invalid API response");
        }
      } catch (error) {
        setError("Error fetching users. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
    fetchUserInfo(selectedUserId);
  }, [selectedUserId]);

  const fetchBankNiftyBids = async (userId) => {
    try {
      const response = await fetch(`https://prod-api.nifty10.com/bankNifty/bid/getWeeklyPlacedBids?userId=${selectedUserId}`);
      const result = await response.json();

      if (result?.data && Array.isArray(result.data)) {
        setBankNiftyBids(result.data);
      } else {
        setBankNiftyBids([]);
      }
    } catch (error) {
      console.error("Error fetching Bank Nifty bids:", error);
      setBankNiftyBids([]);
    }
  };

  // Filter user data after users are loaded
  useEffect(() => {

    if (users.length > 0 && selectedUserId) {
      const filteredUser = users.find(
        (user) => String(user.userId) === String(selectedUserId)
      );
      setUserData(filteredUser || null);
      setSelectedUserId(selectedUserId);
      fetchBids(selectedUserId);
      fetchBankNiftyBids(selectedUserId);

    }
  }, [users, userId, selectedUserId]);
  const fetchUserInfo = async (userId) => {
    try {
      setLoading(true);
      setError(null);
      const url = new URL("https://prod-erp.nifty10.in/user/getUserById");
      url.searchParams.append("userId", userId);

      const response = await fetch(url, {
        method: "GET", // Use GET request
      });
      const data = await response.json();


      if (data.data) {
        setSelectedUserInfo(data.data);
      } else {
        setError("User info not found.");
      }
    } catch (error) {
      setError("Error fetching user info.");
    } finally {
      setLoading(false);
    }
  };
  // Fetch placed bids and calculate totals
  // Fetch placed bids and calculate totals
  const fetchBids = async (userId) => {
    try {
      const url = new URL("https://prod-erp.nifty10.in/user/bids");
      url.searchParams.append("userId", userId);  // Add userId as a query parameter dynamically

      const response = await fetch(url, {
        method: "GET", // Use GET request
      });
      const result = await response.json();

      if (!result?.bids || !Array.isArray(result.bids)) {
        setTodaysBids([]);
        return;
      }

      const allBids = result.bids;

      // Define the UTC boundaries:
      // Today (UTC midnight) and yesterday
      const now = new Date();
      const todayAt9am = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 9, 0, 0, 0);
      const yesterdayAt4pm = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 16, 0, 0, 0);

      // Set the boundaries in UTC:
      // Start: Yesterday at 16:00 UTC
      // End: Today at 09:00 UTC
      const startTimeUTC = new Date(Date.UTC(
        yesterdayAt4pm.getUTCFullYear(),
        yesterdayAt4pm.getUTCMonth(),
        yesterdayAt4pm.getUTCDate(),
        yesterdayAt4pm.getUTCHours() + 5,
        yesterdayAt4pm.getUTCMinutes() + 30,
        yesterdayAt4pm.getUTCSeconds()
      ));
      const endTimeUTC = new Date(Date.UTC(
        todayAt9am.getUTCFullYear(),
        todayAt9am.getUTCMonth(),
        todayAt9am.getUTCDate(),
        todayAt9am.getUTCHours() + 5,
        todayAt9am.getUTCMinutes() + 30,
        todayAt9am.getUTCSeconds()
      ));

      // Debug: Uncomment these lines to check your boundary values in the console
      // console.log("Start Time (UTC):", startTimeUTC.toISOString());
      // console.log("End Time (UTC):", endTimeUTC.toISOString());

      // Filter bids based on the new UTC time boundaries
      const todaysBidList = allBids.filter((bid) => {
        const bidDate = new Date(bid.createdDate); // Assuming bid.createdDate is in a format that JS Date parses as UTC
        return bidDate >= startTimeUTC && bidDate <= endTimeUTC;
      });

      setTodaysBids(todaysBidList);

      // Count bullish and bearish bids from today's bids
      const bullishCount = todaysBidList.filter(
        (bid) => bid.dailyBid.marketName === "Bullish"
      ).length;
      const bearishCount = todaysBidList.filter(
        (bid) => bid.dailyBid.marketName === "Bearish"
      ).length;

      setBullishBids(bullishCount);
      setBearishBids(bearishCount);

      // Filter bids to only include non-free ones for totals
      const todaysNonFreeBids = todaysBidList.filter(
        (bid) => bid.freeBid === false
      );

      // Calculate invested and won amounts based on non-free bids
      const totalInvested = todaysNonFreeBids.reduce(
        (sum, bid) => sum + (bid.paidPoint || 0),
        0
      );
      const totalWon = todaysNonFreeBids.reduce(
        (sum, bid) => sum + (bid.winningPoint || 0),
        0
      );

      // Update user data with today's totals
      setUserData((prev) => ({
        ...prev,
        totalInvested,
        totalWon,
      }));
    } catch (error) {
      console.error("Error fetching bids:", error);
      setTodaysBids([]);
    }
  };
  if (loading) return (
    <div className="loading-container">
      <p className="loading-user-data">Loading user data</p>
    </div>
  );
  if (error) return <p className="error">{error}</p>;
  if (!userData) return <p className="error">User not found</p>;
  if (!userId && !localStorage.getItem("selectedUserId")) return <p>No user selected</p>;

  return (
    <div className="profile-container">
      {/* Header */}
      <button
        className="profile-back-btn"
        onClick={() => setActiveTab("users-info")}
      >
        Back
      </button>
      <div className="profile-header">
        <FaUser className="profile-avatar" />
        <div>
          <h2 className="user-name">{userData?.name || "NA"}</h2>
          <p className="user-type">{userData?.userType || "NA"}</p>
        </div>
        <div className="user-stats">
          <p>
            <strong>Total Invested:</strong> ₹
            {userData?.totalInvested?.toFixed(2) || "0.00"}
          </p>
          <p>
            <strong>Total Won:</strong> ₹
            {userData?.totalWon?.toFixed(2) || "0.00"}
          </p>
        </div>
        <div
          className="payment-history-button"
          onClick={() => setActiveTab("payment-history")}
        >
          Payment History
        </div>

        <div
          className={`status-button ${userData?.isActive ? "active" : "inactive"
            }`}
        >
          {userData?.isActive ? "Active" : "Inactive"}
        </div>
      </div>

      {/* Main Content */}
      <div className="profile-content">
        {/* Left Side */}
        <div className="profile-left">
          {/* Personal Information */}
          <div className="profile-section personal-info">
            <h3>Personal Information</h3>
            <p>
              <FaPhone className="profile-icon" /> {userData?.mobileNo || "NA"}
            </p>
            <p>
              <FaEnvelope className="profile-icon" /> {userData?.email || "NA"}
            </p>
            <p>
              <FaGift className="profile-icon" /> Referral Code:{" "}
              {userData?.referralCode || "NA"}
            </p>
            <p>
              <FaCalendarAlt className="profile-icon" /> Joined:{" "}
              {userData?.createdDate
                ? new Date(userData.createdDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
                : "NA"}
            </p>
            <p>
              <FaUsers className="profile-icon" /> Referrals:{" "}
              {userData?.referralSummary?.referralCount ?? "NA"}
            </p>
            <p>
              <FaMoneyBillWave className="profile-icon" /> Referral Bonus: ₹
              {userData?.referralSummary?.referralBonus ?? "0"}
            </p>
            <p>
              <FaUser className="profile-icon" /> Referred By: {referredByName}
            </p>

          </div>



          {/* Statistics */}
          <div className="profile-section statistics">
            <h3>Statistics</h3>
            <div className="statistics-container">
              <Card
                key={1}
                title="INVESTED MONEY"
                icon="./rupee-symbol.png"
                color="Bullish"
                data={`₹${selectedUserInfo?.investedMoney
                  ? selectedUserInfo.investedMoney.toFixed(2)
                  : "0.00"
                  }`}
              />
              <Card
                key={2}
                title="WALLET"
                icon="./rupee-wallet.png"
                color="Bearish"
                data={`₹${selectedUserInfo?.points ? selectedUserInfo.points.toFixed(2) : "0.00"
                  }`}
              />
              <Card
                key={3}
                title="EARNED MONEY"
                icon="./rupee-symbol.png"
                color="Nifty Prediction"
                data={`₹${selectedUserInfo?.earnedMoney
                  ? selectedUserInfo.earnedMoney.toFixed(2)
                  : "0.00"
                  }`}
              />
            </div>
          </div>

          {/* Bank Details */}
          <div className="profile-section bank-details">
            <h3>Bank Details</h3>
            <p>
              <RiBankLine className="profile-icon" /> Bank Name:{" "}
              {selectedUserInfo?.kycDetails?.bank?.bankName || "NA"}
            </p>
            <p>
              <BsCardList className="profile-icon" /> Account Holder:{" "}
              {selectedUserInfo?.kycDetails?.bank?.accountHolderName || "NA"}
            </p>
            <p>
              <FaIdCard className="profile-icon" /> Account No:{" "}
              {(() => {
                const accountNumber = selectedUserInfo?.kycDetails?.bank?.accountNumber;
                if (!accountNumber || accountNumber.length < 4) {
                  return accountNumber || "NA";
                }
                return "XXXXXX" + accountNumber.substring(accountNumber.length - 4);
              })()}
            </p>

            <p>
              <FaKey className="profile-icon" /> IFSC Code:{" "}
              {selectedUserInfo?.kycDetails?.bank?.ifsc || "NA"}
            </p>
            <p>
              <FaMobileAlt className="profile-icon" /> Verified:{" "}
              <span style={{ color: selectedUserInfo?.kycDetails?.bankVerified ? "green" : "red" }}>
                {selectedUserInfo?.kycDetails?.bankVerified ? "Verified" : "Not Verified"}
              </span>
            </p>
          </div>
          <div className="profile-section ekyc-details">
            <h3>E-KYC Details</h3>
            <div className="statistics-container">
              <Card
                key="aadhaar"
                title="AADHAAR NO"
                icon="./id-card.png"
                color="Bullish"
                data={
                  <>
                    <div>
                      {(() => {
                        const aadhaar = selectedUserInfo?.kycDetails?.aadhaar?.aadhaarNumber;
                        if (!aadhaar || aadhaar.length < 12) {
                          return aadhaar || "NA";
                        }
                        return "XXXX-XXXX-" + aadhaar.substring(8);
                      })()}
                    </div>
                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: selectedUserInfo?.kycDetails?.aadhaarVerified ? "green" : "red",
                        marginTop: "10px"
                      }}
                    >
                      {selectedUserInfo?.kycDetails?.aadhaarVerified ? "Verified" : "Not Verified"}
                    </div>
                  </>
                }
              />
              <Card
                key="pan"
                title="PAN NO"
                icon="./pan-card.png"
                color="Bearish"
                data={
                  <>
                    <div>
                      {(() => {
                        const pan = selectedUserInfo?.kycDetails?.pan?.panNumber;
                        if (!pan || pan.length < 10) {
                          return pan || "NA";
                        }
                        return pan.substring(0, 2) + "XXX" + pan.substring(5);
                      })()}
                    </div>
                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: selectedUserInfo?.kycDetails?.panVerified ? "green" : "red", marginTop: "10px"
                      }}
                    >
                      {selectedUserInfo?.kycDetails?.panVerified ? "Verified" : "Not Verified"}
                    </div>
                  </>
                }
              />
            </div>
          </div>

        </div>
        {/* Right Side: Today's Bids */}

        <div className="bids-card">

          <h3>Today's Bids</h3>
          {/* <p className="bids-count">
            {todaysBids.filter((bid) => bid.freeBid === false).length}
          </p> */}
          <p className="bids-count">{totalTodaysBids}</p>

          {/* Tab Filters */}
          <div className="bids-tab-container">
            <div
              className={`bids-tab-btn ${filterType === "Bullish" ? "active-markets-tab" : ""}`}
              onClick={() => setFilterType("Bullish")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setFilterType("Bullish")}
              style={{
                marginLeft: window.innerWidth >= 768 ? "50px" : "0",
              }}
            >
              Bullish {filterType === "Bullish" && `(${bullishBids})`}
            </div>

            <div
              className={`bids-tab-btn ${filterType === "Bearish" ? "active-markets-tab" : ""}`}
              onClick={() => setFilterType("Bearish")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setFilterType("Bearish")}
            >
              Bearish {filterType === "Bearish" && `(${bearishBids})`}
            </div>

            <div
              className={`bids-tab-btn ${filterType === "BankNifty" ? "active-markets-tab" : ""}`}
              onClick={() => setFilterType("BankNifty")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setFilterType("BankNifty")}
            >
              Bank Nifty ({bankNiftyCounts.total})
            </div>
          </div>

          {filterType === "BankNifty" && (
            <div className="bn-days-tab-container">
              {["MON", "TUE", "WED", "THU", "FRI"].map((day) => (
                <div
                  key={day}
                  className={`bn-day-tab-btn ${selectedBNDay === day ? "active-day-tab" : ""}`}
                  onClick={() => setSelectedBNDay(day)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && setSelectedBNDay(day)}
                >
                  {day} ({bankNiftyCounts[day] || 0})
                </div>
              ))}
            </div>
          )}


          {/* Filtered and Sorted Bids */}
          <div className="bids-card-container">
            {filterType === "BankNifty" ? (
              bankNiftyBids.length > 0 ? (
                bankNiftyBids
                  .filter((bid) => bid.dayCode === selectedBNDay)
                  .map((bid, index) => (
                    <div
                      className={`stat-card ${bid.overallSelectionType === "BULLISH"
                        ? "bullish-border"
                        : bid.overallSelectionType === "BEARISH"
                          ? "bearish-border"
                          : ""
                        }`}
                      key={index}
                    >
                      <div className="bid-type-container">
                        <div
                          className="bids-info-container"
                          onClick={() => {
                            setSelectedBid(bid);
                            setShowInfoModal(true);
                          }}
                        >
                          <BsInfoCircleFill className="bids-info-icon" />
                        </div>
                      </div>
                      {showInfoModal && selectedBid && (
                        <div
                          className="bid-info-modal-overlay"
                          onClick={() => setShowInfoModal(false)}
                        >
                          <div
                            className="bid-info-modal animate-fadeIn"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <h2 className="bid-info-title">Bid Information</h2>
                            <div className="bid-info-row">
                              <span>Day Bid Code:</span>{" "}
                              <strong>
                                {bid.userBidCode || "NA"}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>Market:</span>{" "}
                              <strong>
                                Bank Nifty
                              </strong>
                            </div>
                            {/* <div className="bid-info-row">
                              <span>Entry Fee:</span>
                              <strong>
                                {bid.dailyBid?.freeBid ? (
                                  <>
                                    <del className="free-bid-strike">
                                      ₹{selectedBid.dailyBid?.entryFee || "NA"}
                                    </del>{" "}
                                    <span style={{ color: "green" }}>Free</span>
                                  </>
                                ) : (
                                  <>₹{selectedBid.dailyBid?.entryFee || "NA"}</>
                                )}
                              </strong>
                            </div> */}
                            {/* <div className="bid-info-row">
                              <span>Pool Prize:</span>{" "}
                              <strong>
                                ₹{bid.dailyBid?.poolPrize || "NA"}
                              </strong>
                            </div> */}
                            {/* <div className="bid-info-row">
                              <span>First Prize:</span>{" "}
                              <strong>
                                ₹{bid.dailyBid?.firstPrize || "NA"}
                              </strong>
                            </div> */}
                            {/* <div className="bid-info-row">
                              <span>Total Slots:</span>{" "}
                              <strong>
                                {bid.dailyBid?.bidSlots || "NA"}
                              </strong>
                            </div> */}
                            <div className="bid-info-row">
                              <span>Status:</span>{" "}
                              <strong>
                                {bid.status || "NA"}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>Bid Created At:</span>
                              <strong>
                                {bid?.createdDate
                                  ? (() => {
                                    const date = new Date(
                                      selectedBid.createdDate
                                    );
                                    const day = String(
                                      date.getUTCDate()
                                    ).padStart(2, "0");
                                    const month = String(
                                      date.getUTCMonth() + 1
                                    ).padStart(2, "0"); // months are 0-indexed
                                    const year = date.getUTCFullYear();
                                    const hours = String(
                                      date.getUTCHours()
                                    ).padStart(2, "0");
                                    const minutes = String(
                                      date.getUTCMinutes()
                                    ).padStart(2, "0");
                                    const seconds = String(
                                      date.getUTCSeconds()
                                    ).padStart(2, "0");
                                    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                                  })()
                                  : "NA"}
                              </strong>
                            </div>
                            <button
                              className="cancel-btn1"
                              onClick={() => setShowInfoModal(false)}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      )}
                      {/* BULLISH / BEARISH STOCKS */}
                      <div className="bid-companies">
                        <div className="group-title bullish-title">BULLISH</div>
                        <div className="companies-grid">

                          {bid.bidCompanyList
                            .filter((c) => c.selectionType === "BULLISH")
                            .map((company, i) => (
                              <div
                                key={i}
                                className={`bank-company-tag ${company.specialCompany === "BIG_BULL" ? "big-bull-tag1" : ""
                                  }`}
                              >
                                <span
                                  className={`company-dot ${company.companyStatus === "BULLISH"
                                    ? "bullish-dot"
                                    : "bearish-dot"
                                    }`}
                                ></span>
                                {company.companyName}
                              </div>
                            ))}
                        </div>
                        <div className="group-title bearish-title">BEARISH</div>
                        <div className="companies-grid">
                          {bid.bidCompanyList
                            .filter((c) => c.selectionType === "BEARISH")
                            .map((company, i) => (
                              <div
                                key={i}
                                className={`bank-company-tag ${company.specialCompany === "BIG_BEAR" ? "big-bear-tag1" : ""
                                  }`}
                              >
                                <span
                                  className={`company-dot ${company.companyStatus === "BULLISH"
                                    ? "bullish-dot"
                                    : "bearish-dot"
                                    }`}
                                ></span>
                                {company.companyName}
                              </div>
                            ))}
                        </div>
                      </div>

                      {/* Footer with Time + Points */}
                      <div className="bid-footer">
                        <span className="footer-time">
                          Rank: <strong>{bid.rank ?? "NA"}</strong>
                        </span>
                        <span className="footer-points">
                          Points: <strong>{bid.totalPointCount?.toFixed(2) ?? 0}</strong>
                        </span>
                      </div>
                    </div>

                  ))
              ) : (
                <p>No Bank Nifty bids found.</p>
              )
            ) : (
              todaysBids
                .filter((bid) => bid.dailyBid?.marketName === filterType)
                .sort((a, b) => (a.freeBid === b.freeBid ? 0 : a.freeBid ? 1 : -1))
                .map((bid, index) => (
                  <div className="stat-card" style={{ alignItems: "center" }} key={index}>
                    <div className="bid-type-container">
                      <div
                        className="bids-info-container"
                        onClick={() => {
                          setSelectedBid(bid);
                          setShowInfoModal(true);
                        }}
                      >
                        <BsInfoCircleFill className="bids-info-icon" />
                      </div>

                      {showInfoModal && selectedBid && (
                        <div
                          className="bid-info-modal-overlay"
                          onClick={() => setShowInfoModal(false)}
                        >
                          <div
                            className="bid-info-modal animate-fadeIn"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <h2 className="bid-info-title">Bid Information</h2>
                            <div className="bid-info-row">
                              <span>Day Bid Code:</span>{" "}
                              <strong>
                                {selectedBid.dailyBid?.dayBidCode || "NA"}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>Market:</span>{" "}
                              <strong>
                                {selectedBid.dailyBid?.marketName || "NA"}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>Entry Fee:</span>
                              <strong>
                                {selectedBid.dailyBid?.freeBid ? (
                                  <>
                                    <del className="free-bid-strike">
                                      ₹{selectedBid.dailyBid?.entryFee || "NA"}
                                    </del>{" "}
                                    <span style={{ color: "green" }}>Free</span>
                                  </>
                                ) : (
                                  <>₹{selectedBid.dailyBid?.entryFee || "NA"}</>
                                )}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>Pool Prize:</span>{" "}
                              <strong>
                                ₹{selectedBid.dailyBid?.poolPrize || "NA"}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>First Prize:</span>{" "}
                              <strong>
                                ₹{selectedBid.dailyBid?.firstPrize || "NA"}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>Total Slots:</span>{" "}
                              <strong>
                                {selectedBid.dailyBid?.bidSlots || "NA"}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>Type:</span>{" "}
                              <strong>
                                {selectedBid.dailyBid?.bidType || "NA"}
                              </strong>
                            </div>
                            <div className="bid-info-row">
                              <span>Bid Created At:</span>
                              <strong>
                                {selectedBid?.createdDate
                                  ? (() => {
                                    const date = new Date(
                                      selectedBid.createdDate
                                    );
                                    const day = String(
                                      date.getUTCDate()
                                    ).padStart(2, "0");
                                    const month = String(
                                      date.getUTCMonth() + 1
                                    ).padStart(2, "0"); // months are 0-indexed
                                    const year = date.getUTCFullYear();
                                    const hours = String(
                                      date.getUTCHours()
                                    ).padStart(2, "0");
                                    const minutes = String(
                                      date.getUTCMinutes()
                                    ).padStart(2, "0");
                                    const seconds = String(
                                      date.getUTCSeconds()
                                    ).padStart(2, "0");
                                    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                                  })()
                                  : "NA"}
                              </strong>
                            </div>
                            <button
                              className="cancel-btn1"
                              onClick={() => setShowInfoModal(false)}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="bid-stats-row">
                      <div>
                        <span className="bid-stats-label">Entry Fee: </span>
                        <strong>
                          {bid.freeBid ? (
                            <>
                              <del className="bid-stats-value free-bid-strike">
                                ₹{bid.paidPoint || "NA"}
                              </del>{" "}
                              <span style={{ color: "green" }}>Free</span>
                            </>
                          ) : (
                            <span className="bid-stats-value">
                              ₹{bid.paidPoint || "NA"}
                            </span>
                          )}
                        </strong>
                      </div>
                      <div>
                        <span className="bid-stats-label">Points: </span>
                        <span className="bid-stats-value">
                          {bid.totalPointCount.toFixed(2) ?? 0}
                        </span>
                      </div>
                      <div>
                        <span className="bid-stats-label">Won: </span>
                        <span className="bid-stats-value">
                          {bid.winningPoint !== undefined
                            ? bid.winningPoint.toFixed(2)
                            : "0.00"}
                        </span>
                      </div>
                    </div>
                    <div className="bid-companies">
                      <strong>Companies:</strong>
                      <div className="companies-grid">
                        {bid.listBidCompany?.map((company, i) => (
                          <div
                            key={i}
                            className={`company-tag ${company?.specialCompany
                              ? filterType === "Bullish"
                                ? "big-bull-tag1"
                                : filterType === "Bearish"
                                  ? "big-bear-tag1"
                                  : ""
                              : ""
                              }`}
                          >
                            <span
                              className={`company-dot ${company.companyStatus === "BULLISH"
                                ? "bullish-dot"
                                : "bearish-dot"
                                }`}
                            ></span>
                            {company?.companyName || "Unknown"}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProfileCard;